import { OptionInput } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-form';
import { TarjetaDeCredito } from 'src/app/pago/enums/TarjetaDeCredito.enum';
import { TipoDeTarjeta } from 'src/app/pago/models/TipoDeTarjeta.model';

export class ManagerTarjetaDeCreditoService {
  static readonly TIPOS_DE_TARJETA: TipoDeTarjeta[] = [
    {
      name: TarjetaDeCredito.AMEX,
      pattern: /^3[47]/,
      validLength: 15,
      validPattern: /^\d{15}$/,
      validCvv: 4,
    },
    {
      name: TarjetaDeCredito.DINERS_CLUB,
      pattern: /^30[0-5]/,
      validLength: 14,
      validPattern: /^\d{14}$/,
      validCvv: 3,
    },
    {
      name: TarjetaDeCredito.DINERS,
      pattern: /^36/,
      validLength: 14,
      validPattern: /^\d{14}$/,
      validCvv: 3,
    },
    {
      name: TarjetaDeCredito.VISA,
      pattern: /^4/,
      validLength: 16,
      validPattern: /^\d{16}$/,
      validCvv: 3,
    },
    {
      name: TarjetaDeCredito.MASTERCARD,
      pattern: /^5[1-5]/,
      validLength: 16,
      validPattern: /^\d{16}$/,
      validCvv: 3,
    },
    {
      name: TarjetaDeCredito.MASTERCARD,
      pattern: /^2[36]/,
      validLength: 16,
      validPattern: /^\d{16}$/,
      validCvv: 3,
    },
  ];

  static readonly MONTHS: OptionInput[] = ManagerTarjetaDeCreditoService.createArrayOfOptionInput(
    12
  );

  static readonly CANTIDAD_DE_CUOTAS: OptionInput[] = ManagerTarjetaDeCreditoService.createArrayOfOptionInput(
    36
  );

  static readonly YEARS: OptionInput[] = ManagerTarjetaDeCreditoService.createArrayOfYears(
    13,
    new Date().getFullYear()
  );

  static validarNumero(numeroTarjetaDeCredito: string): boolean {
    let sum = 0;
    let mul = 1;
    let tproduct = 0;
    numeroTarjetaDeCredito
      .split('')
      .reverse()
      .forEach(char => {
        tproduct = parseInt(char, 10) * mul;
        if (tproduct >= 10) {
          sum += (tproduct % 10) + 1;
        } else {
          sum += tproduct;
        }

        if (mul === 1) {
          mul = 2;
        } else {
          mul -= 1;
        }
      });
    return sum % 10 === 0;
  }

  static findTipoDeTarjeta(numeroTarjetaDeCredito: string): TipoDeTarjeta {
    return this.TIPOS_DE_TARJETA.find(cardType =>
      cardType.pattern.test(numeroTarjetaDeCredito)
    );
  }

  private static createArrayOfOptionInput(arraySize: number): OptionInput[] {
    return Array.from(new Array(arraySize), (val, index) => ({
      value: String(index + 1),
      name: String(index + 1),
    }));
  }

  private static createArrayOfYears(
    arraySize: number,
    initialYear: number
  ): OptionInput[] {
    return Array.from(new Array(arraySize), (val, index) => ({
      value: String(initialYear + index),
      name: String(initialYear + index),
    }));
  }
}
